module.exports = __webpack_public_path__ + "static/media/living room-04.8536b4a3.jpg";